import { defineMessages } from "react-intl";

export const messages = defineMessages({
    atPar: {
        id: "UsageBasedPricing.CapacitySidebar.atPar",
        defaultMessage:
            "Your anticipated usage is within the limits of your estimated allowance."
    },
    exceeds: {
        id: "UsageBasedPricing.CapacitySidebar.exceeds",
        defaultMessage:
            "Your anticipated usage may exceed your estimated allowance."
    }
});
